import React from "react";
import "./CertificationsSection.scss";
import karlaCertificate1 from "../assets/files/karla1.pdf";
import karlaCertificate2 from "../assets/files/karla2.pdf";

const certifications = [
  {
    coach: "Karla Rentería",
    image: "/assets/images/karlaThumb.png",
    intro:
      "Fundadora y coach Mentfull con formación en comunicación y entrenamiento.",
    items: [
      "Licenciada en Comunicación",
      "Entrenadora certificada por WABBA Internacional",
      "Acompañamiento en disciplina, constancia y cambio integral",
    ],
    documents: [
      {
        title: "Certificación Karla 1",
        file: karlaCertificate1,
      },
      {
        title: "Certificación Karla 2",
        file: karlaCertificate2,
      },
    ],
  },
  {
    coach: "Xany Naranjo",
    image: "/assets/images/xanyThumb.png",
    intro:
      "Fundadora y coach Mentfull especializada en entrenamiento para mujeres.",
    items: [
      "Certificación en entrenamiento especializado en mujeres",
      "Certificación en entrenamiento enfocado en glúteo",
      "Entrenamiento personal y nutrición deportiva",
    ],
    documents: [],
  },
];

const CertificationsSection = () => {
  return (
    <section className="certifications-section">
      <div className="certifications-inner">
        <div className="certifications-heading">
          <span>Confianza profesional</span>
          <h2>Certificaciones del equipo</h2>
          <p>
            Mentfull combina experiencia, preparación y acompañamiento humano
            para que cada plan tenga intención, estructura y seguimiento.
          </p>
        </div>

        <div className="certification-cards">
          {certifications.map((certification) => (
            <article className="certification-card" key={certification.coach}>
              <div className="certification-photo">
                <img src={certification.image} alt={certification.coach} />
              </div>
              <div className="certification-content">
                <span>Coach Mentfull</span>
                <h3>{certification.coach}</h3>
                <p>{certification.intro}</p>
                <ul>
                  {certification.items.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
                {certification.documents.length > 0 ? (
                  <details className="certification-documents">
                    <summary>Ver documentos que certifican</summary>
                    <div className="certification-documents-list">
                      {certification.documents.map((document) => (
                        <a
                          key={document.title}
                          href={document.file}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <span>{document.title}</span>
                          <strong>Abrir PDF</strong>
                        </a>
                      ))}
                    </div>
                  </details>
                ) : (
                  <p className="certification-pending-documents">
                    Documentos de certificación por agregar.
                  </p>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CertificationsSection;
